<template>
  <div class="commonDialogBody">
    <el-dialog
        :close-on-click-modal='false'
        :title="title"
         :visible.sync="dialogVisible"
        width="70%"
        :destroy-on-close="true"
        :before-close="handleClose">
<div v-show="isType == '0'">
<div  style="width:40%;margin-left:5%;float:left;margin-top:-220px">
    <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" style="width:75%;" >
         <el-form-item :label="formLabelAlign.obj.BillType" >
         <el-select  clearable v-model="BillTypevalue" placeholder="请选择票据类型"  size="small" @change="ChargeBillType" >
            <el-option v-for="item in BillTypeList" :key="item.BillTypevalue" :label="item.BillTypelabel" :value="item.BillTypevalue"></el-option>
        </el-select>
         </el-form-item>
        <el-form-item :label="formLabelAlign.obj.NoteNum" >
         <el-select  clearable v-model="BillNumvalue" placeholder="请选择票据号"  size="small" @change="ChargeBillNum" >
            <el-option v-for="item in BillNumList" :key="item.BillNumvalue" :label="item.BillNumlabel" :value="item.BillNumvalue"></el-option>
        </el-select>
         </el-form-item>
    <el-form-item :label="formLabelAlign.obj.DutyNum" > <!-- 税号 -->
       <el-input v-model="formLabelAlign.DutyNum" size="small"></el-input>
    </el-form-item>
    <el-form-item :label="formLabelAlign.obj.Site"> <!-- 地址 -->
       <el-input v-model="formLabelAlign.Site" size="small"></el-input>
    </el-form-item>
</el-form>
</div>
<div style="width:40%;margin-left:5%;float:left;margin-top:-220px">
    <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" style="width:75%;" >
         <el-form-item :label="formLabelAlign.obj.NoteBook" >
         <el-select  clearable v-model="BillBookvalue" placeholder="请选择票据簿"  size="small" @change="ChargeBillBook" >
            <el-option v-for="item in BillBookList" :key="item.BillBookvalue" :label="item.BillBooklabel" :value="item.BillBookvalue"></el-option>
        </el-select>
         </el-form-item>
    <el-form-item :label="formLabelAlign.obj.payer" > <!-- 付款人 -->
       <el-input v-model="formLabelAlign.payer" size="small"></el-input>
    </el-form-item>
        <el-form-item :label="formLabelAlign.obj.Account" > <!-- 账户 -->
       <el-input v-model="formLabelAlign.Account" size="small"></el-input>
    </el-form-item>
</el-form>

</div>
<div style="width:100%;float:none;margin-top:250px;">
     <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="item" label="项目">
           <template slot-scope="scope">
            <el-select  clearable v-model="scope.row.item" placeholder=""  size="small" @change="ChargeReceiver(scope.row.item)" >
              <el-option v-for="item in receiverList" :key="item.receiverval" :label="item.receiverlab" :value="item.receiverval"></el-option>
            </el-select>
          </template>
      </el-table-column>
      <el-table-column prop="commodity" label="商品编号">
        <template slot-scope="scope">
              <el-input v-model="scope.row.commodity" size="small" disabled></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="years" label="应收年月">
        <template slot-scope="scope">
              <el-input v-model="scope.row.years" size="small"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="unit" label="单位">
        <template slot-scope="scope">
              <el-input v-model="scope.row.unit" size="small"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="Num" label="数量">
        <template slot-scope="scope">
              <el-input v-model="scope.row.Num" size="small" @blur="Quantity(scope.row.Num)"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="price" label="单价">
        <template slot-scope="scope">
              <el-input v-model="scope.row.price" @blur="unitPrice(scope.row.price)"  size="small"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="money" label="金额">
        <template slot-scope="scope">
              <el-input v-model="scope.row.money" size="small" disabled></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="tax" label="税率">
          <template slot-scope="scope">
              <el-input v-model="scope.row.tax" size="small" disabled></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="amount" label="税额">
        <template slot-scope="scope">
              <el-input v-model="scope.row.amount" size="small" disabled></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="course" label="对应科目">
        <template slot-scope="scope">
              <el-input v-model="scope.row.course" size="small"></el-input>
        </template>
      </el-table-column>
    </el-table>
     <el-button type="primary" size="small" plain  @click="AddLine()">添加行</el-button>
      <el-button type="primary" size="small" plain  @click="DelLine()">删除行</el-button>
</div>
<div style="width:40%;margin-left:5%;float:left;margin-top:30px">
    <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" style="width:75%;" >
         <el-form-item :label="formLabelAlign.obj.total" > 
       <el-input v-model="total" size="small" disabled></el-input>
    </el-form-item>
             <el-form-item :label="formLabelAlign.obj.amount" > 
       <el-input v-model="formLabelAlign.amount" size="small" disabled></el-input>
    </el-form-item>
      <el-form-item :label="formLabelAlign.obj.receipt" > 
         <el-date-picker
      v-model="BillDateTime"
      type="datetime"
      @change="inDateTime(BillDateTime)"
      placeholder="选择日期时间">
    </el-date-picker>
    </el-form-item>
    <el-form-item> 
        <el-radio v-model="radio" label="1">纸质发票</el-radio>
    </el-form-item>
          <el-form-item :label="formLabelAlign.obj.proceeds" > 
       <el-input v-model="formLabelAlign.proceeds" size="small" disabled></el-input>
    </el-form-item>
        <el-form-item> 
        <el-radio v-model="print" label="1">打印票据</el-radio>
        <el-radio v-model="print" label="2">无需打印票据</el-radio>
    </el-form-item>
    </el-form>
</div>
<div style="width:40%;margin-left:5%;float:left;margin-top:30px">
     <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" style="width:75%;" >
    <el-form-item :label="formLabelAlign.obj.income" > 
       <el-input v-model="formLabelAlign.income" size="small" disabled></el-input>
    </el-form-item>
        <el-form-item :label="formLabelAlign.obj.remarks" > 
       <el-input v-model="formLabelAlign.remarks" size="small"></el-input>
    </el-form-item>
          <el-form-item :label="formLabelAlign.obj.mode" > 
       <el-select  clearable v-model="receiptval" placeholder="请选择收款方式"   size="small" >
                    <el-option v-for="item in receiptlist" :key="item.receiptval" :label="item.receiptlab" :value="item.receiptval"></el-option>
        </el-select>
    </el-form-item>
    <el-form-item :label="formLabelAlign.obj.invoice" > 
       <el-input v-model="formLabelAlign.invoice" size="small" disabled></el-input>
    </el-form-item>
        <el-form-item :label="formLabelAlign.obj.invoiceDate" > 
       <el-date-picker
      v-model="BillDateTime"
      type="datetime"
      @change="inDateTime()"
      placeholder="选择日期时间">
    </el-date-picker>
    </el-form-item>
     </el-form>
</div>
<div style="width:100%;float:none;height:500px"></div>
</div>
<div v-show="isType == '1'">
  <div style="width:50%;margin-left:5%;float:left;">
   <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" style="width:75%;" >
    <el-form-item :label="formLabelAlign.obj.BillType" > 
        <el-select  clearable v-model="BillTypevalue" placeholder="请选择票据类型"  size="small" @change="ChargeBillType" >
            <el-option v-for="item in BillTypeList" :key="item.BillTypevalue" :label="item.BillTypelabel" :value="item.BillTypevalue"></el-option>
        </el-select>
    </el-form-item>
        <el-form-item :label="formLabelAlign.obj.NoteBook" > 
        <el-select  clearable v-model="BillBookvalue" placeholder="请选择票据簿"  size="small" @change="ChargeBillBook" >
            <el-option v-for="item in BillBookList" :key="item.BillBookvalue" :label="item.BillBooklabel" :value="item.BillBookvalue"></el-option>
        </el-select>
    </el-form-item>
        <el-form-item :label="formLabelAlign.obj.NoteNum" > 
        <el-select  clearable v-model="BillNumvalue" placeholder="请选择票据号"  size="small" @change="ChargeBillNum" >
            <el-option v-for="item in BillNumList" :key="item.BillNumvalue" :label="item.BillNumlabel" :value="item.BillNumvalue"></el-option>
        </el-select>
    </el-form-item>
        <el-form-item :label="formLabelAlign.obj.upmode" > 
      <el-select  clearable v-model="receiptval" placeholder="请选择退款方式" @change="SpayMoth(receiptval)"  size="small" >
            <el-option v-for="item in receiptlist" :key="item.receiptval" :label="item.receiptlab" :value="item.receiptval"></el-option>
        </el-select>
    </el-form-item>
      <el-form-item :label="formLabelAlign.obj.upinvoiceDate" > 
       <el-date-picker
      v-model="BillDateTime"
      type="datetime"
      @change="inDateTimeS(BillDateTime)"
      placeholder="选择日期时间">
    </el-date-picker>
    </el-form-item>

   </el-form>
  </div>
  <div style="width:100%;float:none;height:400px;"></div>
</div>
<div v-show="isType == 'S'">
   <div style="width:35%;margin-left:5%;float:left;">
 <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" style="width:75%;" >
     <el-form-item label="作废时间" > 
       <el-date-picker
      v-model="BillDateTime"
      type="datetime"
      @change="inDateTimeS(BillDateTime)"
      placeholder="选择日期时间">
    </el-date-picker>
    </el-form-item>
        <el-form-item label="作废原因" > 
       <el-input v-model="formLabelAlign.invoice" size="small" ></el-input>
    </el-form-item>
 </el-form>
   </div>
 <div style="width:100%;float:none;height:100px;"></div>
</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="modification()" v-debounce>确 定 </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "CashPledgeDialog",
  data() {
    return {
    tableData:[],
    total:"",
    radio:"1",
    print:"1",
    isType:"",
    options:[],
    value:"",
    BillDateTime:"",
    optionsone: [],
    BatchQuotaList:[],
    valueone: '',
    dialogVisible: false,
    title:"标题",
    titleone:"",
    labelPosition:'right',
    formLabelAlign:{},
    type:"",
    mangroupId:"",
    Pid:"",
    mangroupName:"",
    typeId:"",
    typeName:"",
    groupId:"",
    BillTypeList:[],
    BillTypevalue:"",
        BillNumList:[],
    BillNumvalue:"",
        BillBookList:[],
    BillBookvalue:"",
    unitPriceval:"",
    Quantityval:"",
    receiptlist:[],
    receiptval:"",
    receiverList:[],
    receiverval:"",
    receiverId:"",
    projectIdStr:"",
    customerIdStr:"",
    isDaily:"",
    BillDateTimeS:"",
    receiptvalS:"",
    };
  },
watch:{
  dialogVisible(val){
    if(val == true){
      this.weight()
    }
  }
},
  methods: {
    ChargeReceiver(val){
      for(let valu of this.receiverList){
        if(valu.receiverval == val){
          this.receiverId = valu.taxRate
           for(let price of this.tableData){
              if(price.item == val){
                price.tax = valu.taxRate
                price.course = valu.subjectsCode
              }
            }
        }
      }
    },
      aggregate(){
        //   金额合计
        let num = (this.unitPriceval*1)*(this.Quantityval*1)
        let mon = (num*1).toFixed(2)
        this.total = mon
        for(let val of this.tableData){
          if(this.receiverval == val.item){
            val.money = mon
          }
        }     
      },
      unitPrice(val){
          // 单价
          this.unitPriceval = val
          this.aggregate()
      },
      Quantity(val){
          // 数量
          this.Quantityval = val
          this.aggregate()
      },
inDateTimeS(val){
  	      let date = val;
	    	  let year = date.getFullYear();
	    	  let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1 ): date.getMonth() + 1
	    	  let dates = date.getDate()< 10 ? '0' +date.getDate() : date.getDate()
          let hh = date.getHours()
          let mf = date.getMinutes() < 10 ? '0' + date.getMinutes():date.getMinutes()
          let ss = date.getSeconds() < 10 ? '0' + date.getSeconds():date.getSeconds()
          let time = year+"-"+month+"-"+dates+" "+hh+":"+mf+":"+ss
          this.BillDateTimeS = data.getTime()
},
SpayMoth(val){
  for(let res of this.receiptlist){
    if(res.receiptval == val){
      this.receiptvalS = res.receiptlab
    }

  }
},
    modification(){
      if(this.isType == "1"){
        let obj =         {
  "customerId":this.customerIdStr,
    "isDeposit":"0",
    "projectId":this.projectIdStr,
    "id":this.formLabelAlign.id,
    "invoiceHm":this.BillNumvalue,
    "invoiceDm":this.BillBookvalue,
    "zjSkrq":this.BillDateTimeS,
    "payMethod":this.receiptvalS
}
                this.$http.post("/charge/web/chargeDeposit/depositRefund",obj).then((res)=>{
          if(res.data.code == 200){
            this.$message({
              message: '退款成功',
              type: 'success'
            });
            this.dialogVisible = false
            this.$emit("Visible",false)
          }else{
            this.$message.error(result.msg)
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
        // charge/web/chargeDeposit/depositRefund
      }else if(this.isType == "S"){
        let obj={
          "id":this.formLabelAlign.id,
    "scrapDate":this.BillDateTimeS,
    "scrapDes":this.formLabelAlign.invoice
        }
        console.log(obj)
         this.$http.post("/charge/web/chargeDeposit/cancelRefund",obj).then((res)=>{
          if(res.data.code == 200){
            this.$message({
              message: '作废成功',
              type: 'success'
            });
            this.dialogVisible = false
            this.$emit("Visible",false)
          }else{
            this.$message.error(result.msg)
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
      }else{
           for(let val of this.tableData){
          val.billIds = this.billIdStr
         delete val.asarr
         delete val.display
       }
      //  console.log()
        let obj = {
        "pjlx":this.BillTypevalue, // 选择票据类型
        "invoiceHm":this.BillNumvalue, // 选择票据号
        "invoiceDm":this.BillBookvalue, // 选择票据簿
        "ein":this.formLabelAlign.DutyNum,// 税号
        "address":this.formLabelAlign.address, // 地址
        "payer":this.formLabelAlign.name, // 付款人
        "account":this.formLabelAlign.Account, // 账户
        // 表单
        "bills":this.tableData,
        "remarks":this.formLabelAlign.remarks, // 备注
        "invoiceMan":this.formLabelAlign.payuserName, // 开票人
        "hjsr":this.formLabelAlign.hjsr, // 合计
        "hjse":this.formLabelAlign.hjse, // 合计税额
        "zjSkrq":this.BillDateTime, // 收款日期
        "makeInvoiceDate":this.ReceiptTime, // 开票日期
        "ticket":this.radio, // 纸质发票
        "payee":this.formLabelAlign.payuserName,// 收款人
        "ticket2":this.print,// 是否需要票据
        "projectId":this.projectIdStr,
        "customerId":this.customerIdStr,
        "payMethod":this.receiptTypevalue,
        "hjje":this.formLabelAlign.hjje,
        "isDay":this.isDaily,
     }
     if(this.BillTypevalue == undefined || this.BillTypevalue == ""){
        this.$message({
          message: '请完善票据类型',
          type: 'warning'
        });
     }else if(obj.invoiceDm == undefined || obj.invoiceDm == ""){
 this.$message({
          message: '请完善票据簿',
          type: 'warning'
        });
     }else if(obj.invoiceHm == undefined || obj.invoiceHm == ""){
 this.$message({
          message: '请完善票据号',
          type: 'warning'
        });
     }else if(obj.zjSkrq == undefined || obj.zjSkrq == ""){
 this.$message({
          message: '请完善收款日期',
          type: 'warning'
        });
     }else if(obj.makeInvoiceDate == undefined || obj.makeInvoiceDate == ""){
 this.$message({
          message: '请完善开票日期',
          type: 'warning'
        });
     }else if(obj.payMethod == undefined || obj.payMethod == ""){
 this.$message({
          message: '请完善收款方式',
          type: 'warning'
        });
     }else{
        this.$http.post(this.$requestUrl.POST_CONFIRM_SAVE,obj).then((res)=>{
          if(res.data.code == 200){
            this.$message({
              message: '收款成功',
              type: 'success'
            });
            this.dialogVisible = false
            this.$emit("Visible",false)
          }else{
            this.$message.error(result.msg)
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
     }
      }
     
    //  console.log(obj)
    },

      // 押金收费信息
            AddLine(){
              // 添加行
          let obj = {
              "item":"",
              "commodity":"",
              "years":"",
              "unit":"",
              "Num":"",
              "price":"",
              "money":"",
              "tax":"",
              "amount":"",
              "course":"",
          }
          this.tableData.push(obj)
          // console.log(this.tableData)
           for(let val of this.tableData){
            // console.log(val.money)
          }
      },
      DelLine(){
        // 删除行
          this.tableData.pop()
          // console.log(this.tableData)
          for(let val of this.tableData){
            //  console.log(val.money)
          }
      },
      ChargeBillType(){
        // 选择票据类型
        this.$http.get("/charge/web/chargeInvoiceInhouse/selectInvioce?typeId="+this.BillTypevalue).then((res)=>{
          let data = res.data.data
          let arr = []
          for(let val of data){
            console.log()
            let obj = { 
              "BillBooklabel":val.groupNo,
              "BillBookvalue":val.groupNo,
              "typeName":val.typeName,
              "typeId":val.typeId
            }
            arr.push(obj)
          }
          this.BillBookList = arr
        })
      },
      ChargeBillNum(){
        // 选择票据号
        for(let val of this.BillNumList){
          if(this.BillNumvalue == val.BillNumvalue){
            console.log(val)
            // this.InvoiceBill(val)
          }
        }
      },
      ChargeBillBook(){
        // 选择票据簿
        this.$http.get("/charge/web/chargeInvoiceInhouse/getInvoicesByDm?invoiceDm="+this.BillBookvalue).then((res)=>{
          let data = res.data.data
          // console.log(data)
          let arr = []
          for(let val of data){
            let obj  = {
              "BillNumvalue":val.invoiceHm,
              "BillNumlabel":val.invoiceHm,
              "type":val.invoiceDm,
            }
            arr.push(obj)
          }
          this.BillNumList = arr
        })
      },
    handleClose(done) {
      this.dialogVisible = false
    },
        getDate(){
	    	let date = new Date();
	    	let year = date.getFullYear();
	    	let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1 ): date.getMonth() + 1
	    	let dates = date.getDate()< 10 ? '0' +date.getDate() : date.getDate()
            let hh = new Date().getHours()
            let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes():new Date().getMinutes()
            let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds():new Date().getSeconds()
	    	let arr = ['星期天','星期一','星期二','星期三','星期四','星期五','星期六'];
	    	let day = date.getDay();
            let time = year+"-"+month+"-"+dates+" "+hh+":"+mf+":"+ss
            this.BillDateTime = time
            // console.log('今天是：'+ year +'年' + month + '月' + dates + '日' + hh +":"+ mf+":"+ ss + arr[day])
	    },
      RECEIPT(){
        this.$http.get("/charge/web/chargeMethod/selectList").then((res) => {
          let date = res.data.data
          let arr = []
          for(let val of date){
            let obj = {
              "receiptval":val.id,
              "receiptlab":val.methodName,
            }
            arr.push(obj)
          }
          // console.log(arr)
          this.receiptlist = arr
        })
      },
      weight(){
        // 票据类型 
        this.$http.get("/charge/web/chargeInvoiceInhouse/selectInvioce").then((res)=>{
          let date = res.data.data
          let arr = []
          for(let val of date){
            let obj = {
              "BillTypevalue":val.typeId,
              "BillTypelabel":val.typeName
            }
            arr.push(obj)
          }
          this.BillTypeList = arr
        })
      },
      BatchQuota(){
        // 批量定额 票据簿
        this.$http.get("/charge/web/chargeInvoiceInhouse/selectFixedInvoice").then((res)=>{
          let data = res.data.data
          let array =[
            {
              "BatchQuotavalue":"111",
              "BatchQuotalabel":"当前暂无可选择数据",
               disabled: true,
            }
          ]
          if(data == null){
            data = array
            this.BatchQuotaList = array
          }else{
            let arr =[]
          for(let val of data){
            let obj = {
              "maxMoney":val.maxMoney,
              "BatchQuotavalue":val.groupNo,
              "BatchQuotalabel":val.typeName,
            }
            arr.push(obj)
          }
             this.BatchQuotaList = arr
          }
        })
      },
      weights(){
        this.$http.get(this.$requestUrl.GET_ITEM_WEIGHT).then((res)=>{
           
          let date = res.data.data
          let arr = []
          for(let val of date){
              // console.log(val)
              let obj = {
                "receiverval":val.id,
                "receiverlab":val.feeName,
                "taxRate":val.taxRate,
                "subjectsCode":val.subjectsCode
              }
              arr.push(obj)
            }
          this.receiverList = arr
        })
      },
  },
    mounted() {
       this.BatchQuota()
      this.weights()
      this.RECEIPT()
  },
   beforeMount() {
     if(this.formLabelAlign.obj == undefined){
            let obj = {
                "BillType":"票据类型",
                "NoteBook":"票据簿",
                "NoteNum":"票据号",
                "payer":"付款人",
                "DutyNum":"税号",
                "Account":"账号",
                "Site":"地址",
                "total":"合计",
                "income":"合计收入",
                "amount":"合计税额",
                "remarks":"备注",
                "receipt":"收款日期",
                "mode":"收款方式",
                "hint":"提示用户电子发票有附加信息：",
                "invoice":"开票人",
                "proceeds":"收款人",
                "invoiceDate":"开票日期"

          }
          this.osData = []
      this.formLabelAlign.obj = obj
    }
  },
}
</script>

<style scoped lang="scss">
.el-select-dropdown__item selected{
  color: black;
}
</style>